var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var ViewAllBtn = /** @class */ (function (_super) {
    __extends(ViewAllBtn, _super);
    function ViewAllBtn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ViewAllBtn.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "rj-ev-list__view-all-btn__wrap", "data-uat": "div-ev-list-view-all-btn-wrap" },
            React.createElement("a", { className: "rj-ev-list__view-all-btn__link", href: this.props.linkUrl, onClick: function (e) { return _this.props.onClick(e); }, "data-uat": "div-ev-list-view-all-btn-link" },
                React.createElement("span", { className: "rj-ev-list__view-all-btn__text", "data-uat": "span-ev-list-view-all-btn-text" }, this.props.text))));
    };
    return ViewAllBtn;
}(React.PureComponent));
export { ViewAllBtn };
//# sourceMappingURL=ViewAllBtn.js.map